import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceLockImagePipe } from './device-lock-image.pipe';

@NgModule({
  declarations: [DeviceLockImagePipe],
  imports: [CommonModule],
  exports: [DeviceLockImagePipe],
})
export class DeviceLockImageModule {}
